const rootUrl = "/sazka-klub";
const loginUrl = rootUrl + "/login";

export const settings = {
    url: {
        root: rootUrl,
        login: loginUrl,
        wheel: rootUrl + "/zatocte-si-kolem",
        standalone: rootUrl + "/standalone",
        profile: rootUrl + "/nastaveni",
    },
    authentication: {
        restrictedFunctionsPages: [loginUrl],
    },
};
